import { Box } from '@mui/system';
import { Types } from '@scorenco/core';

import { ScreenView } from './ScreenView';
import { ScreenViewerProvider } from './ScreenViewerContext';
import { ScreenViewerController } from './ScreenViewerController';
import { Timeline } from './Timeline';

type ScreenViewerProps = {
  clubHouse: Types.Clubhouse_Club_House;
};

export const ScreenViewer = ({ clubHouse, ...rest }: ScreenViewerProps) => {
  return (
    <ScreenViewerProvider screens={clubHouse.screens ?? []}>
      <Box {...rest}>
        <ScreenView clubHouse={clubHouse} />
        <Timeline />
        <ScreenViewerController />
      </Box>
    </ScreenViewerProvider>
  );
};
